<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>هدیه روزانه</h4>
          </div>
          <div class="widget-body">
            <form id="licenseForm" class="form-horizontal">
              <!-- license name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سکه روزانه</label>
                <div class="col-lg-6">
                  <input type="text" name="licenseName" class="form-control" v-model="max.count" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/licenses">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import maxService from '../../../../services/daily';
export default {
  name: 'maxConnection',
  data() {
    return {
      max: {},
    };
  },
  created() {
    this.getMax();
  },
  methods: {
    async getMax() {
      try {
        const max = await maxService.getGift();
        this.max = max;
        console.log(max);
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      try {
        await maxService.setGift({ coin: this.max.count });
        this.getMax();
        window.notif({ isError: false, mssg: 'اپدیت شد' });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
